// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kNW2","rootNoMargin":"styles_rootNoMargin__GGkyX"};